module.exports = __webpack_public_path__ + "static/image/company/pc/image_sustainable_policy@3x.ver2_0_2.jpg?66acb515";